import PropTypes from "prop-types"

import { arrayAdd, arrayRemove, arrayReplace } from "shared/lib/utils"

const PopulatorInput = ({ populator = [], onPopulatorChange, disabled }) => {
  return (
    <>
      <div className="field">
        <label />
        <div className="input">
          <div className="dropdown-static-fields action-option">
            <div className="dropdown-static-fields-row">
              <div className="dropdown-static-field label">
                <label>Name</label>
              </div>
              <div className="dropdown-static-field label">
                <label>Value</label>
              </div>
              <div className="delete-row">&nbsp;</div>
            </div>

            {populator.map((entry, index) => (
              <PopulatorOption
                key={index}
                index={index}
                label={entry.label}
                value={entry.value}
                disabled={disabled}
                updateOption={(index, name, value) => {
                  const item = { ...populator[index] }
                  item[name] = value
                  onPopulatorChange(arrayReplace(populator, index, item))
                }}
                removeOption={() => {
                  onPopulatorChange(arrayRemove(populator, index))
                }}
              />
            ))}

            <p>
              <button
                className="button-tertiary"
                disabled={disabled}
                onClick={event => {
                  event.preventDefault()
                  onPopulatorChange(
                    arrayAdd(populator, { label: "", value: "" })
                  )
                }}
              >
                Add an option
              </button>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

const PopulatorOption = ({
  index,
  label,
  value,
  disabled,
  updateOption,
  removeOption,
}) => {
  return (
    <div className="dropdown-static-fields-row">
      <div className="dropdown-static-field">
        <input
          type="text"
          value={label}
          className="key"
          disabled={disabled}
          onChange={e => {
            updateOption(index, "label", e.target.value)
          }}
        />
      </div>
      <div className="dropdown-static-field">
        <input
          type="text"
          value={value}
          className="value"
          disabled={disabled}
          onChange={e => {
            updateOption(index, "value", e.target.value)
          }}
        />
      </div>
      <div className="delete-row">
        {!disabled && (
          <span
            onClick={() => {
              removeOption(index)
            }}
            className="remove-element"
          >
            ×
          </span>
        )}
      </div>
    </div>
  )
}

PopulatorOption.propTypes = {
  index: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  updateOption: PropTypes.func.isRequired,
  removeOption: PropTypes.func.isRequired,
}

PopulatorInput.propTypes = {
  populator: PropTypes.array.isRequired,
  onPopulatorChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default PopulatorInput
